import React from 'react';

import { Button, Modal } from '@attentive-platform/stem-ui';

import { ModalActions, ModalBody, ModalSubtitle, ModalTitle } from '../../styled';

const RemoveCredentialModal = ({ planroom, loading, onClose, onConfirm }) => {
  const handleClose = () => {
    if (loading) return;
    onClose();
  };

  return (
    <Modal
      show
      onClose={handleClose}
      heading={<ModalTitle>Remove credential</ModalTitle>}
      content={
        <ModalBody>
          <ModalSubtitle>{planroom?.name}</ModalSubtitle>
          <p className='m-0 text-sm text-gray-700'>
            This credential will be removed for the company. This action cannot be undone.
          </p>
          <ModalActions>
            <Button size='medium' variant='text' color='primary' disabled={loading} onClick={handleClose}>
              Cancel
            </Button>
            <Button color='error' size='medium' loading={loading} onClick={onConfirm}>
              Remove
            </Button>
          </ModalActions>
        </ModalBody>
      }
    />
  );
};

export default RemoveCredentialModal;
